import React, { useRef, useContext } from 'react';
import { Button } from 'reactstrap';
import { GlobalContext } from './GlobalContext';

// Or, defining and throwing a custom error type
class InternalError extends Error {
  constructor(message) {
    super(message);
    this.name = 'InternalError';
  }
}

const FileUploadButton = ({ conversationID, setStatus, setRefresh }) => {
  // Get our Globals
  const { apiClient } = useContext(GlobalContext);

  // Locals
  const fileInputRef = useRef(null);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      // Check file size
      if (file.size > 25 * 1024 * 1024) {
        setStatus('File size exceeds 25MB. Please select a smaller file.');
        return;
      }
      const fileType = file.name.split('.').pop().toLowerCase(); // Ensure file extension comparison is case-insensitive
      if (!['webm', 'mp3', 'm4a'].includes(fileType)) {
        alert('Invalid file type. Please select a .webm, .mp3, or .m4a file.');
        return;
      }
      setStatus('Uploading audio...');
      try {
        let rsp = await apiClient.addConversationAudioLarge(
          conversationID,
          file,
          60 * 10,
          fileType,
        );
        // console.log(rsp);
        if (rsp['result'] !== 'success') {
          if (rsp['error']) {
            throw new InternalError(rsp['error']);
          } else {
            throw new InternalError('Error uploading audio. Please try again.');
          }
        }
      } catch (error) {
        console.error(error);
        if (apiClient.isTimeoutError(error)) {
          setStatus('Please be patient, the upload is still in progress...');
        } else if (error instanceof InternalError) {
          setStatus(error.message);
        } else {
          setStatus('Error uploading audio. Please try again.');
        }
        return;
      }
      setStatus('Transcribing Complete');
      setRefresh(true);
    }
  };

  const handleClick = () => {
    fileInputRef.current.click(); // Removed the template literals
  };

  return (
    <>
      <input
        type="file"
        style={{ display: 'none' }} // Hide the file input
        ref={fileInputRef}
        onChange={handleFileChange}
      />
      <Button size="med" style={{ marginRight: '10px' }} onClick={handleClick}>
        <i className="fa fa-upload" style={{ fontSize: '18px' }}></i>
      </Button>
    </>
  );
};

export default FileUploadButton;
